import { type QueryFunctionContext } from '@tanstack/vue-query';

import type { ApiResponse, PaginationMetaV2 } from '@abaninja/types';

import { httpClient, unwrap } from '@abaninja/util-http-client';

import type {
  GrantUserSupportAccessToAccountData,
  SearchSupportGrantedAccountParams,
  SupportGrantedAccount,
} from '../@types';

const DEFAULT_ITEMS_PER_PAGE = 100;

export function getSupportGrantedAccounts(
  params: SearchSupportGrantedAccountParams,
  options?: QueryFunctionContext,
) {
  return unwrap(
    httpClient.get<ApiResponse<SupportGrantedAccount[], PaginationMetaV2>>(
      '/users/v1/me/support-granted-accounts', {
        signal: options?.signal,
        params: {
          ...params,
          perPage: params.perPage ?? DEFAULT_ITEMS_PER_PAGE,
        },
      },
    ),
  );
}

export function grantUserSupportAccessToAccount(data: GrantUserSupportAccessToAccountData) {
  return unwrap(
    httpClient.post<ApiResponse<SupportGrantedAccount>>('/users/v1/me/support-granted-accounts', data),
  );
}

export function revokeUserSupportAccessToAccount(uuid: string) {
  return unwrap(
    httpClient.delete(`/users/v1/me/support-granted-accounts/${uuid}`),
  );
}
